import React from "react";
import {
  FlatList,
  Image,
  ImageBackground,
  Pressable,
  Text,
  View,
} from "react-native";
import { tours360Styles } from "@/Components/Screens/Tours360/Tours360Style";
import { useNavigation } from "@react-navigation/native";
import { useGlobal } from "@/Components/Context/globalContext";

interface TourProps {
  vista: any;
}

const Tour = ({ vista }: TourProps) => {
  const navigation = useNavigation<any>();
  const { __, imatgeRecurs } = useGlobal();

  const navigateToVista = (vista) => navigation.navigate("Tours360", { vista });

  return (
    <ImageBackground
      source={{
        uri: vista.miniatura?.url,
      }}
      style={tours360Styles.cardScrollContainer}
      imageStyle={{
        borderRadius: 12,
        borderColor: "white",
        borderWidth: 1,
      }}
    >
      <View
        style={{
          alignItems: "center",
          flex: 1,
          justifyContent: "space-between",
          margin: 0,
        }}
      >
        <View
          style={{
            backgroundColor: "rgba(0,0,0,0.2)",
            width: "100%",
            borderTopRightRadius: 12,
            borderTopLeftRadius: 12,
          }}
        >
          <Text style={tours360Styles.cardScrollName}>{__(vista, "nom")}</Text>
        </View>
        <Pressable
          style={{ ...tours360Styles.buttonScroll360, width: "90%" }}
          onPress={() => navigateToVista(vista)}
        >
          <View style={tours360Styles.buttonContainer}>
            <Image
              source={{ uri: imatgeRecurs("boton_360_grande") }}
              style={tours360Styles.vrVectorStyle}
            />
          </View>
        </Pressable>
      </View>
    </ImageBackground>
  );
};

const Tours360Scroll = () => {
  const { projecte } = useGlobal();

  return (
    <FlatList
      horizontal
      data={projecte.vistes.slice(0, 3)}
      renderItem={({ item, index }) => <Tour key={index} vista={item} />}
      contentContainerStyle={{ flexGrow: 1, justifyContent: "center" }}
      keyExtractor={(item, index) => index.toString()}
    />
  );
};

export default Tours360Scroll;
